<template>
    <v-dialog v-model="dialog" width="650px">
        <v-card>
            <v-card-title>Turnover excel for {{param.huis_code}} </v-card-title>
            
            <v-card-text>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-2">
                     <v-col cols="12" class="pa-2">
                        <v-btn class="success mx-2" small @click="setLastYear">Last year</v-btn>
                        <v-btn class="success mx-2" small @click="setThisYear">This year</v-btn>
                        <!-- <v-btn class="success mx-2" small @click="setYearToDate">Year To Date</v-btn> -->
                        <v-btn class="success mx-2" small @click="changeYear(-1)">year -1</v-btn>
                        <v-btn class="success mx-2" small @click="changeYear(+1)">year +1</v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-4">
                    <v-col cols="5" class="mx-2">
                        <v-menu v-model="dat3menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="param.boek_dat" label="Book date until (inclusive)" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="param.boek_dat2" :first-day-of-week="1" @input="param.boek_dat = $moment(param.boek_dat2).format('DD-MM-YYYY'); dat3menu = false"></v-date-picker>            
                        </v-menu>  
                    </v-col>
                    <v-col cols="5" class="mx-2">
                        <v-checkbox v-model="yearToDate" label="Year to date"></v-checkbox>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-4">
                    <v-col cols="5" class="mx-2">
                        <v-menu v-model="dat1menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="param.van_dat" label="Arrival date from" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
                        </v-menu>  
                    </v-col>
                    <v-col cols="5" class="mx-2">
                        <v-menu v-model="dat2menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="param.tm_dat" label="Arrival date until" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
                        </v-menu>  
                    </v-col>
                </v-row>  
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="ovrz">Create excel</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        <showProgress ref="showProgress"></showProgress>  
    </v-dialog>
</template>

<script>
    import showProgress from "@/components/showProgress.vue"; 

    export default {
        components: {
            showProgress
        },
        data() { 
            return {
                dialog: false,
                huis_encrid: null,
                dat1menu: false,
                dat2menu: false,
                dat3menu: false,
                hulpDate: '',
                param: {},
                yearToDate: false
            }
        },
        methods: {
            open(huis_encrid) {
                this.$emit("showSnackbar");
                this.$axios.post("ares/json/ares/huis/ovrz/getOmzet1Param.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getOmzet1Param"
                    },
                    getOmzet1Param: {
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.param = res.data.getOmzet1Param;
                        this.dialog = true;
                    }
                });
            },

            ovrz2() {
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/huis/ovrz/excelOmzet1.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelOmzet1"
                    },
                    excelOmzet1: {
                        huis_encrid: this.param.huis_encrid,
                        van_dat: this.param.van_dat,
                        tm_dat: this.param.tm_dat
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.items = res.data.excelOmzet1;
                        this.$refs.showProgress.close();
                        window.open(this.items.filename,'_blank');
                    }
                });
            },
            ovrz() {
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/huis/ovrz/excelOmzet2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelOmzet2"
                    },
                    excelOmzet2: {
                        huis_encrid: this.param.huis_encrid,
                        year_to_date: this.yearToDate,
                        boek_dat: this.param.boek_dat,
                        van_dat: this.param.van_dat,
                        tm_dat: this.param.tm_dat
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.items = res.data.excelOmzet2;
                        this.$refs.showProgress.close();
                        window.open(this.items.filename,'_blank');
                    }
                });
            },
            setJaar(jaar) {
                this.param.van_dat = "01-01-" + jaar;
                this.param.van_dat2 = jaar + "-01-01";
                this.param.tm_dat = "31-12-" + jaar;
                this.param.tm_dat2 = jaar + "-12-31";
                this.param.boek_dat = this.param.boek_dat.substring(0,6) + jaar;
                this.param.boek_dat2 = jaar + this.param.boek_dat2.substring(4);
            },
            setLastYear() {
                let nu = new Date();
                this.setJaar(nu.getFullYear() - 1);
            },
            setThisYear() {
                let nu = new Date();
                this.setJaar(nu.getFullYear());
            },
            getMaand(nu) {
                let m = nu.getMonth() + 1;
                if (m >= 10) return m;
                return "0" + m;
            },
            setYearToDate() {
                let nu = new Date();
                this.param.boek_dat = nu.getDate() + "-" + this.getMaand(nu) + "-" +  nu.getFullYear();
                this.param.boek_dat2 =  nu.getFullYear() + "-" + this.getMaand(nu) + "-" + nu.getDate();
            },
            changeYear(offset) {
                let jaar = parseInt(this.param.van_dat.substring(6)) + offset;
                this.param.van_dat = this.param.van_dat.substring(0,6) + jaar;
                this.param.van_dat2 = jaar + this.param.van_dat2.substring(4);
                jaar = parseInt(this.param.tm_dat.substring(6)) + offset;
                this.param.tm_dat = this.param.tm_dat.substring(0,6) + jaar;
                this.param.tm_dat2 = jaar + this.param.tm_dat2.substring(4);
                jaar = parseInt(this.param.boek_dat.substring(6)) + offset;
                this.param.boek_dat = this.param.boek_dat.substring(0,6) + jaar;
                this.param.boek_dat2 = jaar + this.param.boek_dat2.substring(4);
            }
        }
    }
</script>
